import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { Box, IconButton, TableCell, TableRow, Tooltip, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import AddCircleOutlinedIcon from '@mui/icons-material/AddCircleOutlined';
import { ScannerCase } from 'models/scanner-case';

type ScannerCaseItemProps = {
    scannerCase: ScannerCase;
    onCaseClick: (caseId: string) => void;
    onCreateOrderFromCase: (caseId: string) => void;
};
const ScannerCaseItem: FC<ScannerCaseItemProps> = ({ scannerCase, onCaseClick, onCreateOrderFromCase }) => {
    const { t: translate } = useTranslation(['scan-cases']);

    return (
        <TableRow sx={{ cursor: 'pointer' }} hover onClick={() => onCaseClick(scannerCase._id)}>
            <TableCell sx={{ minWidth: 150 }}>
                <Box>{scannerCase.dentist?.name}</Box>
                {scannerCase.clinic?.name ? (
                    <Box>
                        <Typography variant="body2" color="grey.700">
                            {scannerCase.clinic?.name}
                        </Typography>
                    </Box>
                ) : undefined}
            </TableCell>
            <TableCell>
                {scannerCase.patient?.firstName ? (
                    <span>{`${scannerCase.patient?.firstName} ${scannerCase.patient?.lastName || ''}`}</span>
                ) : (
                    <span>{translate('scan-cases:NO_PATIENT_NAME')}</span>
                )}
                {scannerCase.patient?.patientRefNo && (
                    <Typography variant="body2" color="grey.700">
                        {scannerCase.patient?.patientRefNo}
                    </Typography>
                )}
            </TableCell>
            <TableCell sx={{ minWidth: 150 }}>{formatDate(new Date(scannerCase.updatedAt), 'datetime')}</TableCell>
            <TableCell sx={{ maxWidth: 450 }}>
                <Box sx={{ overflow: 'hidden', textOverflow: 'ellipsis', maxHeight: '3em' }}>
                    {scannerCase.comments}
                </Box>
            </TableCell>
            <TableCell sx={{ minWidth: 150 }}>
                {scannerCase.orders && scannerCase.orders.length > 0 ? (
                    <Box>
                        {scannerCase.orders.length} {translate('CONNECTED_ORDERS')}
                    </Box>
                ) : (
                    <Typography variant="body2" color="grey.700">
                        {translate('NO_ORDERS')}
                    </Typography>
                )}
            </TableCell>
            <TableCell>
                <Box display="flex">
                    <Tooltip title={translate('NEW_DENTHUB_ORDER').toString()}>
                        <IconButton color="primary" onClick={() => onCreateOrderFromCase(scannerCase._id)}>
                            <AddCircleOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default ScannerCaseItem;
